import { Component, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../services/toast/toast.service';
@Component({
  selector: 'forgot-password',
  templateUrl: 'forgot-password-form.component.html',
  styleUrls: ['forgot-password-form.component.scss'],
})
export class ForgotPasswordFormComponent {
  email?: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone,
    private toastService: ToastService,
  ) {}

  ngOnInit() {
    if (this.route.snapshot.queryParams.email) {
      this.email = this.route.snapshot.queryParams.email;
    }
  }

  forgotPassword() {
    Accounts.forgotPassword({ email: this.email }, (error: any) => {
      if (error) {
        if (error.error == 403) {
          this.toastService.add({ type: 'ERROR', message: 'userNotFound' });
        } else {
          this.toastService.add({ type: 'ERROR', message: 'serverError' });
        }
        return;
      }
      this.toastService.add({
        type: 'SUCCESS',
        message: 'passwordResetEmailSent',
      });
      this.ngZone.run(() => {
        this.router.navigate(['/login']).then();
      });
    });
  }
}
